"use client";

import { usePathname, useSearchParams } from "next/navigation";

import useGetSearchParams from "@/lib/hooks/useGetSearchParams";
import { ProductCollectionJson, ProductJson } from "@/types/Product.type";

import EmptyProductList from "./EmptyProductList";
import ProductListLoading from "./ProductListLoading";
import ProductCard from "~components/product/ProductCard";
import PaginationServer from "@/components/ui/paginations/PaginationServer";
import {
	AdsItem,
	CollectionAds,
	CollectionAds2,
	CollectionProductRender,
} from "@/types/Collection.type";
import { useEffect, useMemo, useState } from "react";
import { getSettingV2 } from "@/lib/api/shop/setting";
import Collection from "@/common/constants/collection";
import useTimeServer from "@/lib/hooks/useTimeServer";
import Helper from "@/utils/helper";
import { CollectionAdsData } from "@/types/Collection.type";
import ImageV2 from "@/components/ui/ImageV2";
import LinkElement from "@/components/LinkElement";
import { useAppSelector } from "@/redux/hook";

const ProductList = ({
	data,
	isLoading,
	collectionHandle,
	settingAds,
	isApplyAds,
}: {
	data: ProductCollectionJson;
	isLoading?: boolean;
	collectionHandle?: string;
	settingAds?: AdsItem[];
	isApplyAds?: boolean;
}) => {
	const pathname = usePathname();
	const query = useGetSearchParams();
	const { data: timeServer } = useTimeServer();
	const device = useAppSelector((state) => state.ShopReducer.device);

	const dataProductRender: CollectionProductRender = useMemo(() => {
		let defaultData = [...data.items] as CollectionProductRender;
		if (settingAds && isApplyAds) {
			if (settingAds.length > 0 && defaultData.length > 0) {
				defaultData.forEach((data, index) => {
					const ads = settingAds.find((i) => {
						if (device === "desktop") {
							return i.location_view_desktop - 1 === index;
						} else {
							return i.location_view - 1 === index;
						}
					});
					if (
						ads &&
						Helper.checkTimeServer(
							Number(timeServer?.data.date_time || 0),
							ads.from_time,
							ads.to_time
						)
					) {
						defaultData.splice(index, 0, ads);
					}
				});
			}
		}

		return defaultData;
	}, [settingAds, JSON.stringify(data), isApplyAds]);

	return (
		<>
			{isLoading && (
				<div className="mb-16">
					<ProductListLoading />
				</div>
			)}
			{!isLoading && (
				<>
					{dataProductRender.length > 0 ? (
						<div className="grid grid-cols-2 md:grid-cols-4 md:gap-3">
							{dataProductRender.map((item: ProductJson | AdsItem) => {
								if (item.hasOwnProperty("id")) {
									const itemProduct = item as ProductJson;

									return (
										<ProductCard
											sliderImgMobile
											key={itemProduct.id}
											data={itemProduct}
											collectionHandle={collectionHandle}
										/>
									);
								} else {
									const itemAds = item as AdsItem;
									const link = itemAds.data?.[0]?.link || "";
									const image = itemAds.data?.[0]?.img || "";
									if (link.length > 0 && link !== "#") {
										return (
											<LinkElement href={itemAds.data?.[0].img || ""}>
												<ImageV2
													width={device === "desktop" ? 243 : 207}
													height={device === "desktop" ? 326 : 339}
													src={image}
													alt="ads"
													className="w-full h-full"></ImageV2>
											</LinkElement>
										);
									}
									return (
										<div>
											<ImageV2
												width={device === "desktop" ? 243 : 207}
												height={device === "desktop" ? 326 : 339}
												src={image}
												alt="ads"
												className="w-full h-full"></ImageV2>
										</div>
									);
								}
							})}
						</div>
					) : (
						<EmptyProductList />
					)}
				</>
			)}

			<div className="w-full h-[80px] flex justify-center items-center mt-[30px]">
				<PaginationServer
					page={data.currentpage}
					total={Number(data.total)}
					pageSize={data.limit}
					urlSrc={pathname || ""}
					query={query}
				/>
			</div>
		</>
	);
};
export default ProductList;
